var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid"},_vm._l((_vm.imageNames),function(imageName){return _c('img',{key:imageName,attrs:{"src":_vm.getImagePath(imageName),"alt":imageName}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }